const getConfigFieldLabel = (fieldConfig, scope) => {
  const { label, labelForEmployeeGroup, type } = fieldConfig;

  const formatLabel = (rawLabel) =>
    rawLabel && type !== "boolean" ? `${rawLabel}:` : rawLabel;

  if (scope.employeeGroupId) {
    // Use labelForEmployeeGroup if returned from BE, otherwise fall back to label
    return formatLabel(labelForEmployeeGroup || label);
  }

  return formatLabel(label);
};

export default getConfigFieldLabel;
